module.exports = __webpack_public_path__ + "img/glasses-scene1.5b0f304a.png";